export const ru = {
    error: 'Что-то пошло не так, попробуйте повторить позже'
};
